import {
  IColumn,
  Stack,
  Label,
  DetailsList,
  SelectionMode,
} from '@fluentui/react';
import { useState, useEffect } from 'react';
import { formatDate } from '@moko/utils';
import { getIssues, IIssue } from '../../services/issueService';

interface AssetIssuesProps {
  assetId: number;
}

const AssetIssues: React.FC<AssetIssuesProps> = ({ assetId }) => {
  const [issues, setIssues] = useState<IIssue[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchIssues = async () => {
      setIsLoading(true);
      try {
        const abortController = new AbortController();
        const data = await getIssues(
          abortController,
          10,
          1,
          undefined,
          encodeURIComponent(
            JSON.stringify({
              filters: [
                {
                  column: 'ASSET_ID',
                  operation: 'Eq',
                  value: assetId.toString(),
                  type: 'Number',
                },
              ],
            })
          )
        );
        setIssues(data.items);
      } catch (error) {
        console.error('Error fetching asset issues:', error);
      } finally {
        setIsLoading(false);
      }
    };

    if (assetId) {
      fetchIssues();
    }
  }, [assetId]);

  const columns: IColumn[] = [
    {
      key: 'id',
      name: 'ID',
      fieldName: 'id',
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: 'comment',
      name: 'Comment',
      fieldName: 'comment',
      minWidth: 200,
      isResizable: true,
    },
    {
      key: 'createdAt',
      name: 'Created Date',
      fieldName: 'createdAt',
      minWidth: 150,
      maxWidth: 200,
      isResizable: true,
      onRender: (item: IIssue) =>
        item.createdAt ? formatDate(item.createdAt, true) : '',
    },
  ];

  return (
    <Stack tokens={{ childrenGap: 10 }}>
      <Label>Issues for Asset ID: {assetId}</Label>
      {isLoading ? (
        <Label>Loading...</Label>
      ) : (
        <DetailsList
          items={issues}
          columns={columns}
          selectionMode={SelectionMode.none}
          setKey="set"
        />
      )}
    </Stack>
  );
};

export default AssetIssues;
